// Source: https://www.youtube.com/watch?v=uO3kxPAhzmU

const lang = Shopify.locale;
let endless = {
    // (A) PROPERTIES
    //first : true, // LOADING FIRST PAGE?
    proceed: true, // OK TO LOAD MORE PAGES? "LOCK" TO PREVENT LOADING MULTIPLE PAGES
    hasMore: true, // HAS MORE CONTENT TO LOAD?

    // (B) INITIALIZE INFINITE SCROLL
    init: function () {
        // (B1) LISTEN TO END OF PAGE SCROLL - LOAD MORE CONTENTS
        window.addEventListener("scroll", function () {
            if ((window.innerHeight + window.scrollY) >= document.body.offsetHeight - 1000) {
                endless.load();
            }
        });
    },

    // (C) AJAX LOAD CONTENT
    load: function () {

        //console.log('endless', endless)
        if (endless.hasMore) {

            // (C3) LOAD CONTENT
            let articlesJson = document.querySelector('[data-articles-json]');
            console.log(articlesJson)
            if (articlesJson) {
                let articles = JSON.parse(articlesJson.innerHTML);
                let more_articles = articles.results.slice(10);


                let articleHtml = `<div class="md:grid md:grid-cols-3 md:gap-8">`;
                more_articles.forEach((article, index) => {

                    let lang_tag = article.tag
                    if (article.tag === 'Actualité' && lang == 'en')
                        lang_tag = 'News'

                    if (article.tag == 'Avis client' && lang == 'en')
                        lang_tag = 'Testimonials'

                    if (article.tag == 'Le design des espaces de travail' && lang == 'en')
                        lang_tag = 'Workspace design'

                    if (article.tag == 'Le futur du travail' && lang == 'en')
                        lang_tag = 'Futur of work'

                    if (article.tag == 'Travail à distance' && lang == 'en')
                        lang_tag = 'Remote working'

                    if (index + 1 === articles.result_count - 10) { endless.hasMore = false; }

                    /*let image_url = article.image.split('?');
                    let get_ext = image_url[0].split(/\.(?=[^\.]+$)/);
                    let article_image = get_ext[0] + '_600x.' + get_ext[1];*/

                    let article_excerpt = "";
                    if (article.excerpt !== "") {
                        article_excerpt = truncate(article.excerpt, 80, '...')
                    }

                    articleHtml += `<div class="mb-8 lg:mb-10">`;
                    articleHtml += `<a href="${article.url}" aria-label="${article.title}">`;
                    articleHtml += `<div class="relative" style="padding-bottom:75%;">`;
                    articleHtml += `<img src="${article.image}" alt="${article.title}" srcset="${article.image}&width=352 352w, ${article.image}&width=832 832w" width="1000" height="641" class="absolute object-cover object-center w-full h-full" loading="lazy">`;

                    articleHtml += `</div>`;
                    articleHtml += `</a>`;
                    articleHtml += `<div class="relative bg-white p-6 lg:pt-7 z-1 lg:mx-5 lg:-mt-10">`;
                    articleHtml += `<div class="absolute -top-3 left-0 right-0 text-center">`;
                    articleHtml += `<div class="hidden lg:block">`;
                    if (article.tag)
                        articleHtml += `<div class="wwi-btn--tag">${lang_tag}</div>`;
                    articleHtml += `</div>`;
                    articleHtml += `</div>`;
                    articleHtml += `<h2 class="heading heading-4 mb-2">${article.title}</h2>`;
                    articleHtml += `<div class="">${article.excerpt}</div>`;
                    articleHtml += `<div>`;
                    articleHtml += `<a href="${article.url}" class="text-link text-accent" aria-label="${article.title}">${read_more}</a>`;
                    articleHtml += `</div>`;
                    articleHtml += `</div>`;
                    articleHtml += `</div>`;
                    if (index !== 0 && (index + 1) % 3 == 0) {
                        articleHtml += `</div><div class="md:grid md:grid-cols-3 md:gap-8">`;
                    }
                });
                let el = document.createElement("div");
                el.innerHTML = articleHtml;
                document.querySelector(".more-articles").appendChild(el);
            }
        }
    },
}
window.addEventListener("DOMContentLoaded", endless.init);

const truncate = (str, max, suffix) => str.length < max ? str : `${str.substr(0, str.substr(0, max - suffix.length).lastIndexOf(' '))}${suffix}`;